<template>
     <div>
             <div style="width:1300px;margin:0 auto" id="v-content" :style="{minHeight:Height+'px'}">
                 <div class="card mb-5" style="box-shadow: 10px 10px 5px #888888;">
                      <p class="mt-2 mb-0">
                        <span class="p-1 ml-2" style="text-shadow:#000 1px 0 0;background-color:#3190e8;color:#fff;box-shadow: 6px 4px 9px #888888;font-family: Helvetica Neue,Tahoma,Arial;border-radius:3px;">
                            采购计划
                        </span>
                        <span class="ml-5">
                              <span>查询时间从
                                              <span class="yanse" style="font-size:15px;">
                                                      {{searchForm.DateLessThan | changeDate}}
                                                </span>
                                                      到
                                                <span class="yanse" style="font-size:15px;">
                                                        {{searchForm.DateMoreThan | changeDate1}}
                                                </span>
                              </span>
                        </span>
                        <span class="float-right span_close mr-1" style="display:block;width:20px;li   ne-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                        </span>
                      </p>
                      <p class="mb-0 mt-2" style="font-weight:600;color:red;">
                         (单击表头显示列表信息)
                      </p>

                    <div class="row ml-2 mt-2 mb-2">
                               <div class="col-lg-6">
                          <div class="row">
                             <div class="col-lg-12">
                                 <div class="row">

                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        供应商编号:
                                  </div>

                                  <div class="col-lg-4 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.supplierNum"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                <!-- <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        业务员编号:
                                  </div>
                                  <div class="col-lg-4 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.clerkNum"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div> -->
                                <div class="col-lg-4">
                                   <div class="row">
                                        <div class="col-lg-6 p-0 text-center font">
                                        药品名称:
                                  </div>
                                  <div class="col-lg-4 p-0">
                                     <input type="text" class="form-control font" v-model="searchForm.drugNameOrCode"  style="height:1.5rem" @keydown.enter="searchEnterFun">
                                  </div>
                                  </div>
                               </div>
                                 </div>
                             </div>
                          </div>
                       </div>
                        <div class="col-lg-6">
                                <div class="row">
                                        <div class="col-lg-7">
                            <div class="row">
                                <div class="col-lg-6">
                                   <div class="row">
                                      <div class="col-lg-6 P-0">
                                          <div class="row ml-lg-1 p-0 font">
                                              查询日期:
                                          </div>
                                      </div>
                                      <div class="col-lg-6 p-0">
                                              <date3 @changeDate="changeDate1($event)"/>
                                      </div>
                                </div>
                              </div>
                              <div class="col-lg-6">
                                  <div class="row">
                                      <div class="col-lg-6 p-0 text-center font">
                                             到:
                                      </div>
                                      <div class="col-lg-6 p-0">
                                          <date class="picker2"  @changeDate="changeDate2($event)"/>
                                      </div>
                                  </div>
                              </div>
                          </div>
                       </div>
                       <div class="col-lg-5">
                           <div class="row ml-lg-2 ">
                                 <button class="btn-primary font_btn ml-lg-2 w-25 button_zi" @click="getSupplierOrder()">查询</button>
                           </div>
                       </div>
                      </div>
                  </div>
                </div>
                     <div v-if="showPage">
                            <table class="table table-striped table-hover sett">
                                <thead>
                                   <tr style="white-space: nowrap;" @click="changeWidth($event)">
                                                  <th class="autocut">订单号</th>
                                                   <th class="autocut">代理商</th>
                                                  <th class="autocut">供应商</th>
                                                  <th class="autocut">数量</th>
                                                  <th class="autocut">进价</th>
                                                  <th class="autocut">批量价</th>
                                                  <th class="autocut">创建时间</th>
                                                  <th class="autocut">品种编号</th>
                                                  <th class="autocut">品名</th>
                                                  <th class="autocut">产地</th>
                                                  <th class="autocut">包装</th>
                                                  <th class="autocut">剂型或类型</th>
                                                  <th class="autocut">单位</th>
                                                  <th class="autocut">批准文号</th>
                                                  <th class="autocut">状态</th>

                                             </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(item,index) in tableData" :key="index">
  <!-- sett-td -->
                                                 <td class="text-center ">{{item.num}}</td>
                                                  <td class="text-center ">{{item.clerkno}}</td>
                                                  <td class="text-center ">{{item.supplierName}}</td>
                                                  <td class="text-center ">{{item.counts}}</td>
                                                  <td class="text-center ">{{item.purchPrice}}</td>
                                                  <td class="text-center ">{{item.wholePrice}}</td>
                                                  <td class="text-center ">{{item.createDate | utc}}</td>
                                                  <td class="text-center ">{{item.drugNum}}</td>
                                                  <td class="text-center ">{{item.drugName}}</td>
                                                  <td class="text-center ">{{item.factroy}}</td>
                                                  <td class="text-center ">{{item.pack}}</td>
                                                  <td class="text-center ">{{item.drugType}}</td>
                                                  <td class="text-center ">{{item.drugUnit}}</td>
                                                  <td class="text-center ">{{item.approvalNum}}</td>
                                                  <td class="text-center ">{{item.states}}</td>
                                </tr>
                                </tbody>

                            </table>


                                        <!-- 分页 -->
                                               <div>
                                                 <v-pagination :total="total" :current-page='current' @pagechange="pagechange"></v-pagination>
                                               </div>
                                           <p class="text-center">
                                                <img src="../../../static/images/tuding.png" style="width:1.5rem;height:1.5rem;" alt=""/>
                                           </p>


                     </div>
                      <div v-else>

                       <img src="../../../static/images/wushuju.jpg" style="width:300px;height:300px;display:block;margin:0 auto;" alt="">

                     </div>



                    </div>
                </div>
                  <div>
                  <transition name="fade">
                           <loading v-if="isLoading"></loading>
                  </transition>
                </div>
<Watermark
      text="赵璇专用"
      fontSize="20px"
      color="rgba(255, 0, 0, 0.4)"
      rotate="-15"
      opacity="0.4"
    />
     </div>
</template>
<script>
 import vPagination from "../../components/Pagination.vue"
import date from '../../components/Date.vue'
import date3 from '../../components/Date3.vue'
import Loading from '../../components/Loading.vue'
import Watermark from '../../components/Watermark.vue'
export default {
      data(){
          return {
            Height:0,
             showChuang:false,
              showPage:true,
           searchForm: {
           supplierNum:'',
           drugNameOrCode:'',
         searchKey1:'',
         searchKey2:'',
         searchKey3:'',
         clerkNum:'',
          DateMoreThan: '',
          DateLessThan: '' ,
          DateLessThan1: '',
          DateMoreThan1: '',
          DateLessThan_getOrder:'',
        },//搜索内容
        //创建内容
        creation:{
            supplierName:'',
            supplierNum:'',
            drugNum:'',
            drugName:'',
            approvalNum:'',
            clerkNum:'',
            creater:'',
            purchPrice:'',
            wholePrice:'',
            goodsNum:'',


        },
              tableData:[],
                Record: '',//总记录数
                Pcount: '',//总页数
                PageNo: 1 ,//当前页码
                    total:1,     // 记录总条数
                    display: 20,   // 每页显示条数
                    current: 1,   // 当前的页数
                Record1:'',
                Pcount1:'',
                PageNo1:1,
                Record2:'',
                Pcount2:'',
                PageNo2:1,
                isLoading: false,
                supplierList:[],
                drugList:[],


            showChaxun:false,
            showImage:false,
          }
      },
      components:{
          // mheader,
          date,
          // mfooter,
          vPagination,
          Loading,
          date3,
          Watermark
      },
        filters: {
      formatUTC:function(utc_datetime) {
        // 转为正常的时间格式 年-月-日 时:分:秒
           let time=utc_datetime.replace(/T/ig,"  ").substring(0,10)
           let cuttime1=new Date(time).getTime()
           let cuttime2=new Date().getTime()+24*60*60*1000
           if(cuttime1<cuttime2){
             return "批准文号已过期"
           }


        } ,
        utc:function(utc_datetime){
          return utc_datetime.replace(/T/ig,"  ").substring(0,20)
        },
         changeDate(date){
           let change_date=date.slice(0,4)+"-"+date.slice(4,6)+"-"+date.slice(6,9)
           return change_date+" 00:00:00"
      },
      changeDate1(date){
         let time_change=date.slice(0,4)+"-"+date.slice(4,6)+"-"+date.slice(6,9)
        let year=new Date(new Date(time_change).getTime()-24*60*60*1000).getFullYear();

        let month=new Date(new Date(time_change).getTime()-24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(time_change).getTime()-24*60*60*1000).getDate();

        let time;
             if(month<10){
                      if(time_date<10)
                       time=year+"-"+"0"+month+"-"+'0'+time_date;
                      else{
                        time=year+"-"+"0"+month+"-"+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=year+"-"+month+"-"+"0"+time_date;
                     }
                     else{
                       time=year+"-"+month+"-"+time_date;
                     }
                  }

         let change_date=time;
           return change_date+" 23:59:59"
      }
       },
      methods:{
        disableDevTools() {
      // 禁用F12键
      document.addEventListener('keydown', (e) => {
        if (e.key === 'F12') {
          e.preventDefault();
          return false;
        }

        // 禁用Ctrl+Shift+I (开发者工具)
        if (e.ctrlKey && e.shiftKey && e.key === 'I') {
          e.preventDefault();
          return false;
        }

        // 禁用Ctrl+Shift+J (控制台)
        if (e.ctrlKey && e.shiftKey && e.key === 'J') {
          e.preventDefault();
          return false;
        }

        // 禁用Ctrl+U (查看源代码)
        if (e.ctrlKey && e.key === 'u') {
          e.preventDefault();
          return false;
        }

        // 禁用Shift+F10 (上下文菜单)
        if (e.shiftKey && e.key === 'F10') {
          e.preventDefault();
          return false;
        }
      });

      // 禁用右键菜单
      document.addEventListener('contextmenu', (e) => {
        e.preventDefault();
        return false;
      });

      // 监控开发者工具的打开（通过检测控制台输出变化）
      let devtools = {
        open: false,
        orientation: null
      };

      const threshold = 160;

      setInterval(() => {
        if (window.outerHeight - window.innerHeight > threshold ||
            window.outerWidth - window.innerWidth > threshold) {
          if (!devtools.open) {
            devtools.open = true;
            // 可以在这里添加额外的处理逻辑
            console.log('开发者工具已打开');
          }
        } else {
          devtools.open = false;
        }
      }, 500);
    },
          searchEnterFun(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
            this.Search();
         }
      },

      toPath(item) {
        let obj = {
            ypmc: item.drugName,
            cdmc: item.factroy,
            gg: item.specification,
            orderno:item.num
        }
        window.sessionStorage.setItem('upImgObj', JSON.stringify(obj))
        this.$router.push(`/uploadImage?ypbh=${item.drugNum}`)
      },

        searchEnterFun1(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.getSupplierQuery();
         }
      },
      searchEnterFun2(e){
         var keyCode = window.event ? e.keyCode : e.which;
         if(keyCode == 13){
           this.getSupplierDrug();
         }
      },
        //获得编号
        getCode2:function(index){
            // this.creation.drugName=this.drugList[index].drugName;
            // this.creation.approvalNum=this.drugList[index].approvalNum;
            let time=this.drugList[index].approvalDueDate.replace(/T/ig,"  ").substring(0,10)
           let cuttime1=new Date(time).getTime()
           let cuttime2=new Date().getTime()
          //  if(this.drugList[index].syzl==0){
          //      alert("此药品无首营资料,请重新选择")
          //  }
          //  else if(this.drugList[index].state!==''){
          //      alert("此药品已禁用，请重新选择")
          //  }
           if(this.drugList[index].gkpz!=0){
               alert("1.供货单位必须上传监管码 2.管控品种发票要有批号产地")
               this.getSupplierCheckDrug(index);
           }
           else if(this.drugList[index].zbpz==1){
             alert("该品种为集采品种，需上传监管码")
             this.getSupplierCheckDrug(index);
           }
           else{
             this.getSupplierCheckDrug(index);
             }

        },
        getCode1:function(index){
            //  this.supplierList.forEach(element => {
            //      console.log(element.supplierNum)
            //  });
            // this.creation.supplierName=this.supplierList[index].supplierName;
            // this.creation.supplierNum=this.supplierList[index].supplierNum;
            this.getSupplierCheckSupplier(index);

        },
            //动态绑定时间
      changeDate1:function(date){
         this.searchForm.DateLessThan=date.replace(/\-/g, "")
          this.searchForm.DateLessThan1=date;
        },
      changeDate2:function(date){
        let year=new Date(new Date(date).getTime()+24*60*60*1000).getFullYear();

        let month=new Date(new Date(date).getTime()+24*60*60*1000).getMonth()+1;

        let time_date=new Date(new Date(date).getTime()+24*60*60*1000).getDate();
        // console.log(time_date)
        let time;
             if(month<10){
                      if(time_date<10)
                       time=''+year+"0"+month+'0'+time_date;
                      else{
                        time=''+year+"0"+month+time_date;
                      }
                  }
                  else{
                     if(time_date<10){
                       time=''+year+month+"0"+time_date;
                     }
                     else{
                       time=''+year+month+time_date;
                     }
                  }

          this.searchForm.DateMoreThan=time;
          // console.log(time)
          this.searchForm.DateMoreThan1=date;
      },
          //单击改变宽度
           changeWidth:function(e){
               if(e.target.className.indexOf("add_autocut")>-1){

                   $(e.target).removeClass("add_autocut")
               }else{
                   $(e.target).addClass("add_autocut")
               }
      },

          //搜索供应商
          getSupplierQuery:async function(PageIndex){

             this.PageNo2 = PageIndex || this.PageNo2
               const {data:res} = await this.$http.post('Dls/getFun',
               {
                action: 'SupplierQuery',
                obj: JSON.stringify({
                PageIndex,
                searchKey:this.searchForm.searchKey,
              })
             }
               )
              //  console.log(res)
                if (res.isok) {
                    const obj = res.data
                    this.supplierList = obj.rows
                  if(this.supplierList.length>0)
                {
                    this.showChaxun=true;
                    this.showImage=false;
                }
                else{
                    this.showChaxun =false;
                    this.showImage=true;
                }
                    this.Pcount2 = obj.pcount
                    this.Record2 = obj.record
               }
          },
          //搜索药品
          getSupplierDrug:async function(PageIndex){
                 this.PageNo1 = PageIndex || this.PageNo1
               const {data:res} = await this.$http.post('Dls/getFun',
               {
                action: 'SupplierDrug',
                obj: JSON.stringify({
                PageIndex,
                searchKey1:this.searchForm.searchKey1,
                searchKey2:this.searchForm.searchKey2,
                searchKey3:this.searchForm.searchKey3,
              })
             }
               )
              //  console.log(res)
                if (res.isok) {
                    const obj = res.data
                    this.drugList = obj.rows
                     this.Pcount1 = obj.pcount
                    this.Record1 = obj.record

               }
          },
          //检查代理商
          getSupplierCheckClerk:async function(){
               const {data:res} = await this.$http.post('Dls/getFun',
               {
                action: 'SupplierCheckClerk',
                obj: JSON.stringify({
                  clerkNum:window.sessionStorage.getItem("username"),//代理商号
              })
             }
               )
              //  console.log(res)
                if (res.data.result.isSucceed) {
               }
                else{
                  alert("你没有权限")
                }
          },
          //检查供应商
         getSupplierCheckSupplier:async function(index){
               const {data:res} = await this.$http.post('Dls/getFun',
               {
                action: 'SupplierCheckSupplier',
                obj: JSON.stringify({
                  supplierNum:this.supplierList[index].supplierNum,//供应商编号
              })
             }
               )
              //  console.log(res)
                if (res.data.result.isSucceed) {
                       if(res.data.result.msg==""){
                         alert("选择成功")
                         $('#myModal').modal('hide');
                        this.creation.supplierName=this.supplierList[index].supplierName;
                        this.creation.supplierNum=this.supplierList[index].supplierNum;
                       }
                       else{
                            alert(res.data.result.msg)
                         $('#myModal').modal('hide');
                        this.creation.supplierName=this.supplierList[index].supplierName;
                        this.creation.supplierNum=this.supplierList[index].supplierNum;
                       }
               }
               else{
                  alert(res.data.result.msg)

               }
          },
          //检查药品
          getSupplierCheckDrug:async function(index){
              const that=this
               const {data:res} = await that.$http.post('Dls/getFun',
               {
                action: 'SupplierCheckDrug',
                obj: JSON.stringify({
                  supplierNum:that.creation.supplierNum,//供应商编号
                  drugNum:that.drugList[index].drugNum, //药品编号
              })
             }
               )
              //  console.log(res)
              if (res.data.result.isSucceed) {
                  if(res.data.result.msg ==""){
                      alert("选择成功")
                    $('#myModal_yao').modal('hide');
                  that.creation.drugName=that.drugList[index].drugName;
                  that.creation.drugNum=that.drugList[index].drugNum;

                  }
                  else{
                     alert(res.data.result.msg)
                      $('#myModal_yao').modal('hide');
                      that.creation.drugName=that.drugList[index].drugName;
                      that.creation.drugNum=that.drugList[index].drugNum;
                  }
               }
               else{
                 alert(res.data.result.msg)
               }
          },
          // 获取当前时间，day为number，getDay(-1):昨天的日期;getDay(0):今天的日期;getDay(1):明天的日期;【以此类推】
            getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
             getDay1(day) {　
              //  console.log(day)　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                // 　                console.log(today)　
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　
                // console.log(tYear +""+ tMonth +""+ tDate)　
                return tYear +''+ tMonth +''+ tDate;
            },
            doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
        getSupplierOrder: async function (PageIndex) {
              //获取三个月前的时间戳   时间条件适合才可以查询
        const that = this
        let  threeMonth=that.getDay(-3*30);

        let  threeMonthTime=new Date(threeMonth).getTime()

        let  today=that.getDay(0);
        let  todayTime=new Date(today).getTime();

        let  select=that.searchForm.DateLessThan1;

        let  select1=that.searchForm.DateMoreThan1;
        let  seTime=new Date(select).getTime();

        let  seTime2=new Date(select1).getTime();

        let ces=that.searchForm.DateLessThan;
         let a=ces.slice(0,4)+"-"+ces.slice(4,6)+"-"+ces.slice(6,9)
        // console.log(a)
        let ces1=that.searchForm.DateMoreThan;
        let b=ces1.slice(0,4)+"-"+ces1.slice(4,6)+"-"+ces1.slice(6,9)
        // console.log(b)
        let cesTime=new Date(a).getTime();
        // console.log(cesTime)
        let cesTime2=new Date(b).getTime();
        // console.log(cesTime2)
        if(cesTime>=cesTime2){
          alert("开始日期要小于结束日期")
        }
        else{


        if((threeMonthTime<=seTime&&seTime<=todayTime) && (threeMonthTime<=seTime2&&seTime2<=todayTime)){

        this.isLoading=true;

        if(!PageIndex){PageIndex=1}
        that.PageNo = PageIndex || that.PageNo
        const {data: res} = await this.$http.post('Dls/getFun', {
          action: 'SupplierOrders',
          obj: JSON.stringify({
            PageIndex,
            clerkNum:that.searchForm.clerkNum,
             ipcode:localStorage.getItem("ipcode"),
            supplierNum:that.searchForm.supplierNum,
            drugNameOrCode:that.searchForm.drugNameOrCode,
            createDateStart: that.searchForm.DateLessThan,  // 销售日期不小于
            createDateEnd: that.searchForm.DateMoreThan, // 销售日期不大于
          })
        })

        //  console.log(res)
        if(res.isok){
              const obj = res.data;
               if(obj.rows==null){
                that.tableData = []
                that.Pcount = 0
                that.Record = 0
                that.total = 0
               this.showPage =false;
                that.isLoading=false;
return;
              }
               that.tableData = obj.rows
                  if(this.tableData.length>0)
                        {
                            this.showPage=true;
                        }
                        else{
                            this.showPage =false;
                        }
                  that.Pcount = obj.pcount
                  that.Record = obj.record
                  that.total = obj.record
                that.showChuang = true;
                that.isLoading=false;

        }


          }
          else{
            alert("请选择三个月以内的时间进行查询,查询日期不大于当天")
          }



        }

      },
      //创建报计划


       pagechange:function(currentPage){

           this.getSupplierOrder(currentPage);

     },

       curPage1: function (index) {

        //  if(this.searchData.length>0){
        //     this.Search(index)
        //  }
        //  else{
           this.getSupplierDrug(index)
        //  }
      },
      //上一页
      prePage1: function () {
        if (this.PageNo1 > 1) {
          this.PageNo1--;
          //  if(this.searchData.length>0){
          //   this.Search(this.PageNo1)
          // }
          // else{

            this.getSupplierDrug(this.PageNo1);
          // }
        }
      },
      //下一页
      nextPage1: function () {
        if (this.PageNo1 < this.Pcount1) {
          this.PageNo1++;
          // if(this.searchData.length>0){
          //   this.Search(this.PageNo1)
          // }
          // else{
            this.getSupplierDrug(this.PageNo1);
          // }
        }
      },
      //当前页
       curPage2: function (index) {

        //  if(this.searchData.length>0){
        //     this.Search(index)
        //  }
        //  else{
           this.getSupplierQuery(index)
        //  }
      },
      //上一页
      prePage2: function () {
        if (this.PageNo2 > 1) {
          this.PageNo2--;
          //  if(this.searchData.length>0){
          //   this.Search(this.PageNo1)
          // }
          // else{

            this.getSupplierQuery(this.PageNo2);
          // }
        }
      },
      //下一页
      nextPage2: function () {
        if (this.PageNo2 < this.Pcount2) {
          this.PageNo2++;
          // if(this.searchData.length>0){
          //   this.Search(this.PageNo1)
          // }
          // else{
            this.getSupplierQuery(this.PageNo2);
          // }
        }
      },
        change1(){
               $("#myModalLabel").text("查询");
               $('#myModal').modal();
        },
        change2(){
             if(!this.creation.supplierName){
                  alert("请先选择供应商名称")
                }else{
                  $("#yaoping").text("查询");
                  $('#myModal_yao').modal();
                }
        }
      },
      mounted(){

      },
    mounted(){
    this.Height = document.documentElement.clientHeight - 100;
    window.onresize = ()=> {this.Height = document.documentElement.clientHeight -100}

    },
      created(){
         this.disableDevTools();
        //this.getSupplierCheckClerk()
          this.searchForm.DateMoreThan=this.getDay1(1)
          this.searchForm.DateLessThan=this.getDay1(-7)
          this.searchForm.DateLessThan1=this.getDay(-8)
          this.searchForm.DateMoreThan1=this.getDay(0)
          this.getSupplierOrder()
      }
}
</script>
<style scoped>
    .hei{
        height:1.5rem;
    }
     .font_btn{
         font-size:10px!important;
     }
     .jz_title{
          vertical-align: middle;
     }
     .sou_container{
         position:absolute;
         flex-wrap: wrap;
         top:35%;
         left:50%;
         transform: translateX(-50%) translateY(-50%);
     }
   .input_sou{
       width:300px;
       height:35px;
       font-size:20px;
   }
   .font_sou{
       font-size:20px;
   }
   .button_sou{
      height:35px;
   }
   .font{
    font-size:15px;
  }
  .button_zi{
      text-shadow:#000 1px 0 0;
      border-radius: 5px;
      border:none;
      color:azure;
  }
 .sett{
        width:1300px;
        table-layout:fixed;

  }
  .sett-td {

    white-space:nowrap;

    overflow:hidden;

    text-overflow:ellipsis;

   -moz-text-overflow: ellipsis;

}

/deep/ .btn .el-button--mini {
    padding: 4px 8px;
}

.autocut{
     overflow:hidden;
      white-space:nowrap;
      text-overflow:ellipsis;
      -o-text-overflow:ellipsis;
     -khtml-text-overflow: ellipsis;
     -moz-text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
}
 .autocut:hover
 {
     overflow:visible;
     width:200px;
     white-space:nowrap;
     word-wrap: break-word;
     text-align:center;
 }
 .add_autocut{
    overflow:visible;
     width:200px;
     white-space:nowrap;
     word-wrap: break-word;
     text-align:center;
 }
 .hei{
     height:1.5rem;
 }
 .alert_show{
    position:absolute;
    top:81px;
    left:450px;
 }
 .yanse{
   color:red;
 }
 .yanse1{
   color:green;
 }
 .disabled_state{
   color:red;
   font-size:15px;
   /* border:.1px solid red; */
 }
 .jz_middle{
   vertical-align:middle;
 }
 .span_close:hover{
       color:#3190e8;
 }
 .input_form-control {
/* // display: block;  */
width: 50%;
height: 34px;
padding: 6px 12px;
font-size: 14px;
line-height: 1.428571429;
color: #555555;
vertical-align: middle;
background-color: #ffffff;
border: 1px solid #cccccc;
border-radius: 4px;
-webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
-webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;
}
.input_form-control:focus {
border-color: #66afe9;
outline: 0;
-webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);
box-shadow: inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);
}
.input_form-control:disabled{
    border: 1px solid #DDD;
    background-color: #F5F5F5;
    color:#ACA899;opacity: 1;
}
.table_chuang{
  width:1000px;
  height:400px;
  margin:0 auto;
}
.jz_middle{
   vertical-align:middle;
 }
</style>



// WEBPACK FOOTER //
// src/pages/Lihui/ZxPlan.vue